module.exports = __webpack_public_path__ + "static/media/Sec-1_2677_Banner_CN_Mobile.428f527a.png";